export const incrementCounter = ({ dispatch }) => dispatch('INCREMENT', 1);



/** WEBPACK FOOTER **
 ** ./src/vuex/actions.js
 **/